<style>
    @media print {
        @page {
            size: letter portrait;
            margin: 10mm 5mm 5mm 5mm;
        }

        .page-break {
            page-break-before: always;
            counter-increment: pageCounter;
        }

        .page-counter::after {
            content: "Page " counter(pageCounter);
        }

        .footer,
        #non-printable {
            display: none !important;
        }

        #printable {
            display: block;
        }

        body {
            font-size: 100%;
        }

        table,
        td,
        th {
            font-size: 100%;
        }
        
        .page {
            page-break-after: always;
            counter-increment: pageCounter;
        }

        .page-footer {
            width: 100%;
            background-color: transparent !important;
            display: block;
            margin-top: 185mm;
        }
    }

    table {
        background-color: white !important;
        color: black !important;
    }

    table tr {
        font-family: "Courier";
        line-height: normal;
        font-size: 12px;
    }

    .text-bold {
        font-weight: bold;
    }

    .text-left {
        text-align: left;
    }

    .text-right {
        text-align: right;
    }

    .text-center {
        text-align: center;
    }

    #page-counter {
        display: table-footer-group;
    }

    .border-bottom {
        border-bottom: 1px dashed;
    }

    .text-align-top {
        vertical-align: top;
    }
</style>

<template>
    <div>
        <div v-for="(dataPerDoc, dataPerDocIndex) in pageData" :key="`dataPerDoc-${dataPerDocIndex}`">
            <div
                v-for="(dataPerDocPage, dataPerDocPageIndex) in dataPerDoc"
                :key="`dataPerDocPage-${dataPerDocPageIndex}`"
                style="page-break-before: always"
            >
                <table width="100%">
                    <tr>
                        <td style="text-align: center; padding-bottom: 4px; font-size: 14px">
                            <div><strong>HANDOVER</strong></div>
                            <div>
                                <strong>{{ dataPerDocPage.company_name }}</strong>
                            </div>
                        </td>
                    </tr>
                </table>
                <br>
                <table width="100%">
                    <tr>
                        <td style="width: 135px;">Cabang</td>
                        <td>:</td>
                        <td>{{ dataPerDocPage.warehouse_code }} - {{ dataPerDocPage.warehouse_name }}</td>
                        <td style="width: 20px;"></td>
                        <td>Print</td>
                        <td>:</td>
                        <td>{{ dataPerDocPage.print_counter }}</td>
                    </tr>
                    <tr>
                        <td>Shipment Number</td>
                        <td>:</td>
                        <td>
                            <nobr>{{ dataPerDocPage.shipment_number }}</nobr>
                        </td>
                        <td style="width: 20px;"></td>
                        <td>Print date</td>
                        <td>:</td>
                        <td>{{ printDatetime }}</td>
                    </tr>
                    <tr>
                        <td style="position: absolute;">PI Number(s)</td>
                        <td style="vertical-align: top;">:</td>
                        <td style="max-width: 25px;">{{ dataPerDocPage.delivery_order_codes }}</td>
                        <td style="width: 20px;"></td>
                        <td style="vertical-align: top;">Page</td>
                        <td style="vertical-align: top;">:</td>
                        <td style="vertical-align: top;">
                            {{ dataPerDocPage.page }} of {{ dataPerDocPage.totalPages }}
                        </td>
                    </tr>
                    <tr>
                        <td>Tanggal Shipment</td>
                        <td>:</td>
                        <td>
                            <nobr>{{ formatDate(dataPerDocPage.shipment_date) }}</nobr>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Driver</td>
                        <td>:</td>
                        <td>
                            <nobr>{{ dataPerDocPage.driver_name }}</nobr>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Vehicle Number</td>
                        <td>:</td>
                        <td>
                            <nobr>{{ dataPerDocPage.vehicle_number }}</nobr>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
                <br>
                <table width="100%">
                    <thead>
                        <tr style="border-top: 2px dashed; border-bottom: 2px dashed" v-if="dataPerDocPage.lines.length != 0">
                            <td style="width: 30px">No</td>
                            <td>Sku Code</td>
                            <td>Item Name</td>
                            <td>Batch</td>
                            <td>Exp. Date</td>
                            <td>Quantity</td>
                            <td>Unit</td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(line, indexLine) in dataPerDocPage.lines">
                            <tr :key="`item-line-${indexLine}`">
                                <td style="padding-top: 2px;">
                                    {{ line.row_number }}
                                </td>
                                <td style="padding-top: 2px;">
                                    {{ line.sku_code }}
                                </td>
                                <td style="padding-top: 2px;">
                                    {{ truncateText(line.item_name, 25) }}
                                </td>
                                <td style="padding-top: 2px;">
                                    {{ line.batch }}
                                </td>
                                <td style="padding-top: 2px;">
                                    {{ line.exp_date }}
                                </td>
                                <td style="padding-top: 2px;">
                                    {{ line.quantity }}
                                </td>
                                <td style="padding-top: 2px;">
                                    {{ line.unit }}
                                </td>
                            </tr>

                            <!-- jika terdapat lebih dari 1 halaman -->
                            <tr
                                v-if="(dataPerDoc[dataPerDoc.length-1].lines.length > 0 && indexLine == dataPerDocPage.lines.length - 1 && dataPerDocPageIndex < dataPerDoc.length - 1 && dataPerDocPage.lines.length <= linePerPage) || (dataPerDoc[dataPerDoc.length-1].lines.length == 0 && indexLine == dataPerDocPage.lines.length - 1 && dataPerDocPageIndex < dataPerDoc.length - 2 && dataPerDocPage.lines.length == linePerPage)"
                                :key="`item-dashed-line-${indexLine}`"
                                style="border-top: 2px dashed"
                            >
                                <td style="padding-top: 2px;">&nbsp;</td>
                            </tr>

                            <!-- jika hanya menggunakan 1 halaman saja -->
                            <tr
                                v-if="(indexLine == dataPerDocPage.lines.length - 1 && dataPerDocPageIndex == dataPerDoc.length - 1) || (dataPerDoc[dataPerDoc.length-1].lines.length == 0 && indexLine == dataPerDocPage.lines.length - 1 && dataPerDocPage.lines.length <= linePerPage && dataPerDocPageIndex == dataPerDoc.length - 2)"
                                style="border-top: 2px dashed"
                                :key="`message-final-${indexLine}`"
                            >
                                <td style="padding-top: 2px;">&nbsp;</td>
                            </tr>
                            <tr
                                :key="`item-total2-${indexLine}`"
                                v-if="indexLine == dataPerDocPage.lines.length - 1 && dataPerDocPageIndex == dataPerDoc.length - 1"
                            >
                                <td colspan="12">
                                    <table style="width: 100%">
                                        <div v-if="38 - dataPerDocPage.lines.length > 0">
                                            <template v-for="index in 38 - dataPerDocPage.lines.length">
                                                <tr :key="`space-${index}`">
                                                    <td style="padding-top: 2px;">&nbsp;</td>
                                                </tr>
                                            </template>
                                        </div>

                                        <tr>
                                            <th style="text-align: center">Diserahkan oleh</th>
                                            <th style="text-align: center">Diterima oleh</th>
                                            <th style="text-align: center">Diketahui oleh</th>
                                        </tr>
                                        <tr>
                                            <th style="height: 50px"></th>
                                            <th style="height: 50px"></th>
                                            <th style="height: 50px"></th>
                                        </tr>
                                        <tr>
                                            <th style="text-align: center">Checker</th>
                                            <th style="text-align: center">Driver</th>
                                            <th style="text-align: center">SPV Logistic</th>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <table
                    style="width: 100%"
                    v-if="dataPerDocPage.lines.length < limitLastLine && dataPerDoc.length > 1 && dataPerDocPage.lines.length == 0"
                >
                    <template v-for="index in 38 - dataPerDocPage.lines.length">
                        <tr :key="`space-${index}`">
                            <td style="padding-top: 2px;">&nbsp;</td>
                        </tr>
                    </template>
                    <tr>
                        <th style="text-align: center">Diserahkan oleh</th>
                        <th style="text-align: center">Diterima oleh</th>
                        <th style="text-align: center">Diketahui oleh</th>
                    </tr>
                    <tr>
                        <th style="height: 50px"></th>
                        <th style="height: 50px"></th>
                        <th style="height: 50px"></th>
                    </tr>
                    <tr>
                        <th style="text-align: center">Checker</th>
                        <th style="text-align: center">Driver</th>
                        <th style="text-align: center">SPV Logistic</th>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
export default {
    name: "PrintPDF",
    data() {
        return {
            id: 0,
            handoverIds: null,
            datas: [],
            timeNow: "",
            printDatetime: moment().format("DD.MM.YYYY HH:mm:ss"),
            counter: 0,
            pageData: [],
            linePerPage: 38,
            limitLastLine: 33,
        }
    },
    mounted() {
        this.handoverIds = window.opener.handoverIds;
        if (this.handoverIds.length) {
            this.print();
        }
    },
    methods: {
        async print() {
            const tempTitle = document.title;
            await this.getData();
            await window.print();
            document.title = tempTitle;
        },
        async getData() {
            this.$vs.loading();
            let resp = await this.$http.get(`/api/wms/v1/simple-outbound-processing/print-handover-driver`,
                {
                    params: {
                        handover_ids: this.handoverIds,
                        is_print: 1
                    } 
                }
            );
            if (resp.code == 200) {
                this.datas = resp.data;
                document.title = this.datas.reduce(
                    (prev, curr) => `${prev}-${curr.shipment_number}`, "HANDOVER"
                );
                var pageData = [];
                var limitLastLine = this.limitLastLine;

                this.datas.forEach((data, indexDoc) => {
                    var dataPerDocument = [];
                    var dataPerDocumentLines = [];
                    var linePerPageCounter = 0;
                    var rowNumber = 1;
                    var pageNumber = 0;

                    data.item_lines.forEach((line, indexLine) => {
                        linePerPageCounter++;

                        if (linePerPageCounter == 1) {
                            dataPerDocumentLines = [];
                        }
                        line.row_number = rowNumber;
                        rowNumber++;
                        dataPerDocumentLines.push(line);

                        if (linePerPageCounter == this.linePerPage || indexLine == data.item_lines.length - 1) {
                            let dataPerPage = { ...data };
                            dataPerPage.lines = [];
                            dataPerPage.lines = dataPerDocumentLines;
                            pageNumber++
                            dataPerPage.page = pageNumber
                            dataPerPage.totalPages = 1
                            dataPerDocument.push(dataPerPage);
                            linePerPageCounter = 0;
                        }
                    });

                    if (dataPerDocument.length > 0) {
                        if (dataPerDocument[dataPerDocument.length - 1].lines.length > limitLastLine) {
                            let dataPerPage = {
                                ...dataPerDocument[dataPerDocument.length - 1],
                            };
                            dataPerPage.lines = [];
                            dataPerPage.totalPages = dataPerDocument.length
                            dataPerDocument.push(dataPerPage);
                        }
                    }

                    pageData.push(dataPerDocument);
                });

                this.pageData = pageData;
            } else {
                console.log(resp.message)
            }
            this.$vs.loading.close();
        },
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                const halfLength = Math.floor((maxLength - 3) / 2)
                const start = text.substring(0, halfLength)
                const end = text.substring(text.length - halfLength)
                return `${start}...${end}`
            }
            return text;
        },
    },
    watch: {
        counter: {
            handler: function (val) {
                console.log("counter => ", val);
            },
            deep: true,
        },
    },
    computed: {
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format("YYYY-MM-DD");
            };
        },
        formatTime: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format("hh:mm:ss");
            };
        },
        formatNumber: () => {
            return (val) => {
                if (val == null) {
                    return 0;
                }
                return Intl.NumberFormat("id", { minimumFractionDigits: 0 }).format(
                    val
                );
            };
        },
    },
}
</script>